import { slideUp, slideDown } from "@common/slide";
import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-enterprises").forEach((el) => {
  const slider = el.querySelector(".swiper");

  const swiper = new Swiper(slider, {
    modules: [A11y, Autoplay, EffectFade],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
  });

  el.querySelectorAll(".enterprise-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      if (trigger.getAttribute("aria-expanded") === "false") {
        const currentTrigger = el.querySelector('.enterprise-trigger[aria-expanded="true"]');
        const currentTarget = el.querySelector(`#${currentTrigger.getAttribute("aria-controls")}`);

        const index = parseInt(trigger.dataset.index);
        const target = el.querySelector(`#${trigger.getAttribute("aria-controls")}`);

        currentTrigger.setAttribute("aria-expanded", "false");
        trigger.setAttribute("aria-expanded", "true");

        slideUp(currentTarget);
        slideDown(target);

        swiper.slideTo(index - 1);
      }
    });
  });
});
